
export const UserConstraints = ()=>{


    const UserConstantsData = () => {
        return (
            {
                storageUsername:"",
                storageIsRememberMe:false,
            }
        )
    }
    return({
        UserConstantsData
    })

}

